module.exports = __webpack_public_path__ + "img/albania.89f8c45f.svg";